module.exports = __webpack_public_path__ + "static/media/IMG_1186-min.a8a94ca2.jpg";